import ClaimIVEContainer from "./ClaimIVEContainer";

export default ClaimIVEContainer;